module.exports = "/assets/368d85a6107344b21ae87b5f5aa24ff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/check_icon.png
// module id = 480
// module chunks = 0